import React from "react";
import { QuizQuestion } from "../../models/QuizQuestion.model";

interface Props {
  question: QuizQuestion;
  onSubmitAnswer: (answer: string) => void;
}

function MultipleChoiceForm(props: Props) {
  const { question, onSubmitAnswer } = props;

  const correctAnswerIndex = Math.floor(Math.random() * 4);
  const allAnswers = [
    ...question.wrongAnswers.slice(0, correctAnswerIndex),
    question.correctAnswer,
    ...question.wrongAnswers.slice(correctAnswerIndex),
  ];

  return (
    <form className="multi-choice-form">
      <h3>{question.titleText}</h3>
      <p>Q: {question.questionText}</p>
      <ul>
        {allAnswers.map((a) => {
          return (
            <li key={a}>
              <button onClick={() => onSubmitAnswer(a)} type="button">
                {a}
              </button>
            </li>
          );
        })}
      </ul>
      {/* <button type="submit" className='form-submit-btn'>Submit</button> */}
    </form>
  );
}

export default MultipleChoiceForm;
